@if (exibir) {
  <div class="simple-modal" role="dialog" aria-modal="true" aria-labelledby="pix-modal-titulo">
    <div class="simple-modal-dialog modal-lg">
      <div class="simple-modal-content">
        <div class="simple-modal-header">
          <h5 class="simple-modal-title" id="pix-modal-titulo">
            {{ pixPreview?.title }}
          </h5>
          <button type="button" class="btn-close" aria-label="Fechar" (click)="toggle()"></button>
        </div>
        <div class="simple-modal-body">
          <embed [src]="trustedUrl" type="application/pdf" width="220px" height="220px" title="QR Code Pix" aria-label="Visualização do QR Code Pix" />
          <button type="button" (click)="copiaECola()" class="btn btn-primary copia">
            <i class="bi bi-clipboard" aria-hidden="true"></i> {{ 'pix_modal.copiar_codigo' | translate }}
          </button>
          @if (exibeMensagem) {
            <div role="status" aria-live="polite">{{ 'pix_modal.texto_copiado' | translate }}</div>
          }
        </div>
      </div>
    </div>
  </div>
  <div (click)="toggle()" class="overlay" aria-hidden="true"></div>
}
